import Utils from 'common/utils'

const APP_VERSION = 19;

export default class VersionManager {
    // Get the app version
    static getAppVersion() {
        return APP_VERSION
    }

    static isAppVersionLatest(remoteVersionArg) {
        var remoteVersion = null;
        if (false === Utils.isNull(remoteVersionArg)) {
            if (typeof (remoteVersionArg) === "string") {
                // Convert string to number
                var versionIntVal = parseInt(remoteVersionArg, 10)
                if (false === isNaN(versionIntVal)) {
                    remoteVersion = versionIntVal;
                }
            } else if (typeof (remoteVersionArg) === "number") {
                remoteVersion = remoteVersionArg;
            }
        }

        // If version is null, then assume that what the app has is the latest
        if (Utils.isNull(remoteVersion)) {
            return true;
        }
        return this.getAppVersion() >= remoteVersion;
    }
}



// WEBPACK FOOTER //
// ./src/manager/versionManager.js